import { IResvInf } from "interface/book";
import BookInf from ".";
import BookCard from "../bookCard";
import RmInf from "./rmInf";

type IProps = {
  resvInf: IResvInf | any;
  handleResvCancel(): void;
};

export default function BookInfView({ resvInf, handleResvCancel }: IProps) {
  const payInf = {
    resvAmt: resvInf?.resvAmt,
    payAmt: resvInf?.payAmt,
    payStaCd: resvInf?.payStaCd,
    payStaNm: resvInf?.payStaNm,
    rmChkInDt: resvInf?.rmChkInDt,
  };

  return (
    <>
      <BookInf payInf={payInf} handleResvCancel={handleResvCancel}>
        <BookCard resvInf={resvInf} lodVisible={true} />
        <RmInf resvInf={resvInf} />
      </BookInf>
    </>
  );
}
